import _ from 'lodash';

class LocalStorage {
    public static add(key: string, value: string) {
        if (_.isString(value)) {
           localStorage.setItem(key, value);  
        } else {
           throw new Error(`invalid value: ${value}, should be a string`);
        }
     }

    public static get(key: string) {
        if (LocalStorage.has(key)) {
            return localStorage.getItem(key);
        }

        return null;
    }

    public static remove(key: string) {
        if (LocalStorage.has(key)) {
            localStorage.removeItem(key);
        }
    }

    public static has(key: string): boolean {
        return !!localStorage.getItem(key);
    }
}

export default LocalStorage;
